import axios from 'axios';

const LOG_TAG = '[AIPromptEngineer]';
const isDevelopment = process.env.NODE_ENV === 'development';

function summarizeOptimizationRequest(promptEngineerConfig, draftInstructions) {
    return {
        source: promptEngineerConfig?.source || '',
        version: promptEngineerConfig?.version || '',
        industry: promptEngineerConfig?.business?.industry || '',
        audience: promptEngineerConfig?.business?.audience || '',
        mainJob: promptEngineerConfig?.role?.mainJob || '',
        originalInstructionLength: draftInstructions?.length || 0
    };
}

function devLog(eventName, payload) {
    if (!isDevelopment) return;
    console.log(LOG_TAG, eventName, payload);
}

export async function optimizePromptInstructions(promptEngineerConfig, draftInstructions) {
    const summary = summarizeOptimizationRequest(promptEngineerConfig, draftInstructions);
    devLog('optimization_started', summary);

    try {
        const response = await axios.post('/prompt-engineer/optimize-instructions', {
            promptEngineerConfig,
            draftInstructions
        });

        if (!response?.data?.success || !response?.data?.optimizedInstructions) {
            throw new Error(response?.data?.message || 'Instruction optimization failed.');
        }

        devLog('optimization_succeeded', {
            ...summary,
            optimizedInstructionLength: response.data.optimizedInstructions.length
        });

        return response.data.optimizedInstructions;
    } catch (error) {
        devLog('optimization_failed', {
            ...summary,
            message: error?.message || 'Instruction optimization failed.'
        });
        throw error;
    }
}
